angular.module("faq.components", ["app.services"]).component("faq", {
  templateUrl: "ng/components/faq/faq.view.html",
  bindings: {

  },
  controllerAs: "faqCtrl",
  controller: function ($instantLeasingService, $financialApiService) {
    var self = this;

    self.$onInit = function () {
      self.question = "";
      self.noResult = false;
      self.loading = false;

      self.recoverFaq();
    };

    self.recoverFaq = function () {
      self.loading = true;
      $instantLeasingService
        .recoverFaq()
        .then(function (response) {
          self.loading = false;
          self.mapAppFaq = response.mapAppFaq;
        })
        .catch(function (err) {
          console.log("La chiamata è andata in errore: ", err);
        })
        .finally(function () {
          self.loading = false;
        });
    };

    self.searchFaq = function (question) {
      self.loading = true;
      if (question) {
        $financialApiService
          .searchFaq(question)
          .then(function (response) {
            self.mapAppFaq = {};
            self.loading = false;
            var lunghezza = response && response.mapAppFaq && Object.keys(response.mapAppFaq).length

            if (lunghezza > 0) {
              self.mapAppFaq = response.mapAppFaq;
              self.noResult = false;
            } else {
              self.noResult = true;
            }
          })
          .catch(function (err) {
            console.log("La chiamata è andata in errore: ", err);
          })
          .finally(function () {
            self.loading = false;
          });
      } else {
        self.recoverFaq();
      }
    };

    self.handleChange = function (value) {
      self.question = value;
    }

    /**
     * it cloases all accordion with id != id
     */
    self.closeOthers = function (id) {
      $(".panel-collapse").collapse("hide");
    }
  }
});